import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--narrow js-main-content" }
const _hoisted_2 = {
  key: 0,
  class: "_flexcol _gap-4 _fd-r--l"
}
const _hoisted_3 = { class: "gfu-1of1 gfu-1of2--l" }
const _hoisted_4 = { class: "_flex _jc-st _ai-c" }
const _hoisted_5 = { class: "_flex _jc-st _ai-c" }
const _hoisted_6 = { class: "gfu-1of1 gfu-1of2--l" }
const _hoisted_7 = {
  class: "_mt-2",
  "data-qa": "account-settings:Avatar"
}
const _hoisted_8 = { class: "_pos-r _mt-1" }
const _hoisted_9 = { class: "_mt-2" }
const _hoisted_10 = { class: "_mt-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_account_navigation = _resolveComponent("account-navigation")
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_text_field = _resolveComponent("text-field")
  const _component_field_edit = _resolveComponent("field-edit")
  const _component_field = _resolveComponent("field")
  const _component_icon_base_button = _resolveComponent("icon-base-button")
  const _component_saved_credit_cards = _resolveComponent("saved-credit-cards")
  const _component_field_label = _resolveComponent("field-label")
  const _component_base_image = _resolveComponent("base-image")
  const _component_switch_field = _resolveComponent("switch-field")
  const _component_text_area_field = _resolveComponent("text-area-field")
  const _component_box = _resolveComponent("box")
  const _component_account_delete_confirmation = _resolveComponent("account-delete-confirmation")
  const _component_change_password_modal = _resolveComponent("change-password-modal")
  const _component_change_email_modal = _resolveComponent("change-email-modal")
  const _component_avatar_manager_modal = _resolveComponent("avatar-manager-modal")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_account_navigation, { "page-identity": $data.pageID }, null, 8 /* PROPS */, ["page-identity"]),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_base_heading, {
        tag: "h2",
        class: "gfu-heading--main _mt-6"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.AccountSettings.AccountDetailsSectionTitle), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_box, { class: "_mt-6" }, {
        default: _withCtx(() => [
          ($options.user)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_base_heading, {
                    tag: "h2",
                    class: "gfu-heading--text"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.AccountSettings.AccountDetailsSectionTitle), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_field, {
                    modelValue: $data.model.fullName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.fullName) = $event)),
                    name: "model.fullName",
                    "display-name": _ctx.Resources.AccountSettings.FullNameFieldLabel,
                    description: _ctx.Resources.AccountSettings.FullNameFieldDescription,
                    "data-qa": "account-settings:FullName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_field_edit, {
                        name: "model.fullName",
                        class: "_ai-c _jc-st",
                        onEdit: $options.onEdit,
                        onSave: $options.onSave,
                        onCancel: $options.onCancel
                      }, {
                        default: _withCtx(({ onSave, onCancel, isEditing }) => [
                          _createVNode(_component_text_field, {
                            ref: "fullName",
                            modelValue: $data.model.fullName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.fullName) = $event)),
                            placeholder: _ctx.Resources.AccountSettings.FullNameFieldPlaceholder,
                            class: "_mt-0 _mr-1 _grow-1",
                            "show-label": false,
                            disabled: !isEditing,
                            onKeyup: [
                              _withKeys(onSave, ["enter"]),
                              _withKeys(onCancel, ["esc"])
                            ]
                          }, null, 8 /* PROPS */, ["modelValue", "placeholder", "disabled", "onKeyup"])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onEdit", "onSave", "onCancel"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue", "display-name", "description"]),
                  _createVNode(_component_field, {
                    "display-name": "Email",
                    "data-qa": "account-settings:Email"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_text_field, {
                          modelValue: $options.user.email,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($options.user.email) = $event)),
                          "display-name": _ctx.Resources.AccountSettings.EmailFieldLabel,
                          class: "_mt-0 _mr-1 _grow-1",
                          disabled: true,
                          "show-label": false,
                          placeholder: _ctx.Resources.AccountSettings.EmailFieldPlaceholder
                        }, null, 8 /* PROPS */, ["modelValue", "display-name", "placeholder"]),
                        _createVNode(_component_icon_base_button, {
                          theme: "lightAlt",
                          shape: "circle",
                          icon: "pen",
                          "only-icon": true,
                          onClick: _withModifiers($options.onChangeEmail, ["prevent"]),
                          "data-qa": "field-action:Edit"
                        }, null, 8 /* PROPS */, ["onClick"])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_field, {
                    "display-name": _ctx.Resources.AccountSettings.PasswordFieldLabel
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_text_field, {
                          value: "**********",
                          "display-name": _ctx.Resources.AccountSettings.PasswordFieldLabel,
                          class: "_mt-0 _mr-1 _grow-1",
                          conceal: true,
                          type: "password",
                          disabled: true,
                          "show-label": false
                        }, null, 8 /* PROPS */, ["display-name"]),
                        _createVNode(_component_icon_base_button, {
                          theme: "lightAlt",
                          shape: "circle",
                          icon: "pen",
                          "only-icon": true,
                          onClick: _withModifiers($options.onChangePassword, ["prevent"]),
                          "data-qa": "account-settings-button:ChangePassword"
                        }, null, 8 /* PROPS */, ["onClick"])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["display-name"]),
                  _createVNode(_component_saved_credit_cards, {
                    class: "_my-6",
                    "saved-cards": $data.savedCards,
                    onCardDeleted: $options.onCardDeleted
                  }, null, 8 /* PROPS */, ["saved-cards", "onCardDeleted"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_base_heading, {
                    tag: "h2",
                    class: "gfu-heading--text"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.AccountSettings.ProfileCustomizationSectionTitle), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_field, {
                    "display-name": _ctx.Resources.AccountSettings.NicknameFieldLabel,
                    name: "model.nickname",
                    description: _ctx.Resources.AccountSettings.NicknameFieldDescription,
                    "data-qa": "account-settings:Nickname"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_field_edit, {
                        name: "model.nickname",
                        class: "_ai-c _jc-st",
                        onEdit: $options.onEdit,
                        onSave: $options.onSave,
                        onCancel: $options.onCancel
                      }, {
                        default: _withCtx(({ onSave, onCancel, isEditing }) => [
                          _createVNode(_component_text_field, {
                            ref: "nickname",
                            modelValue: $data.model.nickname,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.model.nickname) = $event)),
                            class: "_mt-0 _mr-1 _grow-1",
                            placeholder: _ctx.Resources.AccountSettings.NicknameFieldPlaceholder,
                            "show-label": false,
                            disabled: !isEditing,
                            onKeyup: [
                              _withKeys(onSave, ["enter"]),
                              _withKeys(onCancel, ["esc"])
                            ]
                          }, null, 8 /* PROPS */, ["modelValue", "placeholder", "disabled", "onKeyup"])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onEdit", "onSave", "onCancel"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["display-name", "description"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_field_label, {
                      text: _ctx.Resources.AccountSettings.AvatarFieldLabel
                    }, null, 8 /* PROPS */, ["text"]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_base_image, {
                        src: $data.model.avatarImageUrl,
                        width: 140,
                        height: 140,
                        class: "gfu-avatar",
                        "data-qa": "account-settings:AvatarPreview"
                      }, null, 8 /* PROPS */, ["src"]),
                      _createVNode(_component_icon_base_button, {
                        class: "_pos-a",
                        theme: "lightAlt",
                        shape: "circle",
                        icon: "pen",
                        "only-icon": "",
                        onClick: _withModifiers($options.openAvatarManagerModal, ["prevent"]),
                        "data-qa": "account-settings:EditAvatar"
                      }, null, 8 /* PROPS */, ["onClick"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_switch_field, {
                      modelValue: $data.model.isPublicField,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = $event => (($data.model.isPublicField) = $event)),
                        $options.onChangeIsPublic
                      ],
                      name: "isPublic",
                      "show-label": false,
                      class: "_mt-3",
                      "true-label": _ctx.Resources.AccountSettings.IsPublicFieldOnLabel,
                      "false-label": _ctx.Resources.AccountSettings.IsPublicFieldOffLabel,
                      "display-name": _ctx.Resources.AccountSettings.IsPublicFieldLabel,
                      "data-qa": "account-settings:IsPublic"
                    }, null, 8 /* PROPS */, ["modelValue", "true-label", "false-label", "display-name", "onUpdate:modelValue"])
                  ]),
                  _createVNode(_component_field, {
                    "display-name": _ctx.Resources.AccountSettings.BioFieldLabel,
                    class: "_mt-6",
                    description: _ctx.Resources.AccountSettings.BioFieldDescription
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_field_edit, {
                        name: "model.bio",
                        class: "_jc-st",
                        onEdit: $options.onEdit,
                        onSave: $options.onSave,
                        onCancel: $options.onCancel,
                        "data-qa": "account-settings:Bio"
                      }, {
                        default: _withCtx(({ onSave, onCancel, isEditing }) => [
                          _createVNode(_component_text_area_field, {
                            ref: "bio",
                            modelValue: $data.model.bio,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.model.bio) = $event)),
                            class: "_mt-0 _mr-1 _grow-1",
                            name: "model.bio",
                            rows: "6",
                            "display-name": _ctx.Resources.AccountSettings.BioFieldLabel,
                            "show-label": false,
                            disabled: !isEditing,
                            maxlength: 300,
                            onKeyup: [
                              _withKeys(onSave, ["enter"]),
                              _withKeys(onCancel, ["esc"])
                            ]
                          }, null, 8 /* PROPS */, ["modelValue", "display-name", "disabled", "onKeyup"])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onEdit", "onSave", "onCancel"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["display-name", "description"]),
                  _createVNode(_component_field, {
                    "display-name": _ctx.Resources.AccountSettings.InstagramFieldLabel,
                    description: _ctx.Resources.AccountSettings.InstagramFieldDescription,
                    name: "model.instagramUrl",
                    "data-qa": "account-settings:Instagram"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_field_edit, {
                        name: "model.instagramUrl",
                        class: "_ai-c _jc-st",
                        onEdit: $options.onEdit,
                        onSave: $options.onSave,
                        onCancel: $options.onCancel
                      }, {
                        default: _withCtx(({ onSave, onCancel, isEditing }) => [
                          _createVNode(_component_text_field, {
                            ref: "instagramUrl",
                            modelValue: $data.model.instagramUrl,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.model.instagramUrl) = $event)),
                            class: "_mt-0 _mr-1 _grow-1",
                            placeholder: _ctx.Resources.AccountSettings.InstagramFieldPlaceholder,
                            "show-label": false,
                            disabled: !isEditing,
                            onKeyup: [
                              _withKeys(onSave, ["enter"]),
                              _withKeys(onCancel, ["esc"])
                            ]
                          }, null, 8 /* PROPS */, ["modelValue", "placeholder", "disabled", "onKeyup"])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onEdit", "onSave", "onCancel"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["display-name", "description"]),
                  _createVNode(_component_field, {
                    "display-name": _ctx.Resources.AccountSettings.FacebookFieldLabel,
                    description: _ctx.Resources.AccountSettings.FacebookFieldDescription,
                    name: "model.facebookUrl",
                    "data-qa": "account-settings:Facebook"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_field_edit, {
                        name: "model.facebookUrl",
                        class: "_ai-c _jc-st",
                        onEdit: $options.onEdit,
                        onSave: $options.onSave,
                        onCancel: $options.onCancel
                      }, {
                        default: _withCtx(({ onSave, onCancel, isEditing }) => [
                          _createVNode(_component_text_field, {
                            ref: "facebook",
                            modelValue: $data.model.facebookUrl,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($data.model.facebookUrl) = $event)),
                            placeholder: _ctx.Resources.AccountSettings.FacebookFieldPlaceholder,
                            class: "_mt-0 _mr-1 _grow-1",
                            "show-label": false,
                            disabled: !isEditing,
                            onKeyup: [
                              _withKeys(onSave, ["enter"]),
                              _withKeys(onCancel, ["esc"])
                            ]
                          }, null, 8 /* PROPS */, ["modelValue", "placeholder", "disabled", "onKeyup"])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onEdit", "onSave", "onCancel"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["display-name", "description"]),
                  _createVNode(_component_field, {
                    "display-name": _ctx.Resources.AccountSettings.TwitterFieldLabel,
                    description: _ctx.Resources.AccountSettings.TwitterFieldDescription,
                    name: "model.twitterUrl",
                    "data-qa": "account-settings:Twitter"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_field_edit, {
                        name: "model.twitterUrl",
                        class: "_ai-c _jc-st",
                        onEdit: $options.onEdit,
                        onSave: $options.onSave,
                        onCancel: $options.onCancel
                      }, {
                        default: _withCtx(({ onSave, onCancel, isEditing }) => [
                          _createVNode(_component_text_field, {
                            ref: "twitter",
                            modelValue: $data.model.twitterUrl,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($data.model.twitterUrl) = $event)),
                            placeholder: _ctx.Resources.AccountSettings.TwitterFieldPlaceholder,
                            class: "_mt-0 _mr-1 _grow-1",
                            "show-label": false,
                            disabled: !isEditing,
                            onKeyup: [
                              _withKeys(onSave, ["enter"]),
                              _withKeys(onCancel, ["esc"])
                            ]
                          }, null, 8 /* PROPS */, ["modelValue", "placeholder", "disabled", "onKeyup"])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onEdit", "onSave", "onCancel"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["display-name", "description"]),
                  _createVNode(_component_field, {
                    "display-name": _ctx.Resources.AccountSettings.YoutubeFieldLabel,
                    name: "model.youtubeUrl",
                    description: _ctx.Resources.AccountSettings.YoutubeFieldDescription,
                    "data-qa": "account-settings:Youtube"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_field_edit, {
                        name: "model.youtubeUrl",
                        class: "_ai-c _jc-st",
                        onEdit: $options.onEdit,
                        onSave: $options.onSave,
                        onCancel: $options.onCancel
                      }, {
                        default: _withCtx(({ onSave, onCancel, isEditing }) => [
                          _createVNode(_component_text_field, {
                            ref: "youtube",
                            modelValue: $data.model.youtubeUrl,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($data.model.youtubeUrl) = $event)),
                            class: "_mt-0 _mr-1 _grow-1",
                            placeholder: _ctx.Resources.AccountSettings.YoutubeFieldPlaceholder,
                            "show-label": false,
                            disabled: !isEditing,
                            onKeyup: [
                              _withKeys(onSave, ["enter"]),
                              _withKeys(onCancel, ["esc"])
                            ]
                          }, null, 8 /* PROPS */, ["modelValue", "placeholder", "disabled", "onKeyup"])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onEdit", "onSave", "onCancel"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["display-name", "description"])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      ($setup.isCelebrationFeatureEnabled)
        ? (_openBlock(), _createBlock(_component_box, {
            key: 0,
            class: "_mt-6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_heading, {
                tag: "h2",
                class: "gfu-heading--text"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.AccountSettings.CelebratoryEffectsSectionTitle), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("p", null, _toDisplayString(_ctx.Resources.AccountSettings.CelebratoryEffectsSectionText), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_switch_field, {
                  modelValue: $options.areCelebratoryEffectsEnabled,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($options.areCelebratoryEffectsEnabled) = $event)),
                  name: "celebratoryEffects",
                  "show-label": false,
                  class: "_mt-3",
                  "true-label": _ctx.Resources.AccountSettings.CelebratoryEffectsFieldOnLabel,
                  "false-label": _ctx.Resources.AccountSettings.CelebratoryEffectsFieldOffLabel,
                  "display-name": _ctx.Resources.AccountSettings.CelebratoryEffectsFieldLabel,
                  "data-qa": "account-settings:CelebratoryEffects"
                }, null, 8 /* PROPS */, ["modelValue", "true-label", "false-label", "display-name"])
              ])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_box, { class: "_mt-6" }, {
        default: _withCtx(() => [
          _createVNode(_component_base_heading, {
            tag: "h2",
            class: "gfu-heading--text"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.AccountSettings.DeleteAccountSectionTitle), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.Resources.AccountSettings.DeleteAccountSectionText) + " ", 1 /* TEXT */),
            _createElementVNode("a", {
              href: "",
              class: "gfu-link gfu-link--accent",
              onClick: _cache[11] || (_cache[11] = _withModifiers((...args) => ($options.onDeleteAccount && $options.onDeleteAccount(...args)), ["prevent"])),
              "data-qa": "account-settings-button:DeleteAccount"
            }, _toDisplayString(_ctx.Resources.AccountSettings.DeleteAccountLink), 1 /* TEXT */),
            _cache[12] || (_cache[12] = _createTextVNode(". ", -1 /* CACHED */))
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createVNode(_component_account_delete_confirmation, {
      "is-visible": $data.isDeleteAccountModalVisible,
      onClose: $options.onDeleteModalClose
    }, null, 8 /* PROPS */, ["is-visible", "onClose"]),
    ($data.isChangePasswordModalVisible)
      ? (_openBlock(), _createBlock(_component_change_password_modal, {
          key: 0,
          "user-id": $options.user.userID,
          onPasswordChanged: $options.onPasswordChanged,
          onClose: $options.onChangePasswordModalClose
        }, null, 8 /* PROPS */, ["user-id", "onPasswordChanged", "onClose"]))
      : _createCommentVNode("v-if", true),
    ($data.isChangeEmailModalVisible)
      ? (_openBlock(), _createBlock(_component_change_email_modal, {
          key: 1,
          email: $options.user.email,
          "pending-new-email": $options.user.newEmail,
          "user-id": $options.user.userID,
          onEmailChanged: $options.onEmailChanged,
          onClose: $options.onChangeEmailModalClose
        }, null, 8 /* PROPS */, ["email", "pending-new-email", "user-id", "onEmailChanged", "onClose"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_avatar_manager_modal, {
      "is-open": $data.isAvatarManagerModalVisible,
      "avatar-image-url": $data.model.avatarImageUrl,
      "uses-platform-avatar": $data.model.usesPlatformAvatar,
      "avatar-hash": $data.model.avatarHash,
      onClose: $options.onCloseAvatarManagerModal,
      onImageUploaded: $options.onImageUploaded,
      onAvatarChanged: $options.onAvatarChanged
    }, null, 8 /* PROPS */, ["is-open", "avatar-image-url", "uses-platform-avatar", "avatar-hash", "onClose", "onImageUploaded", "onAvatarChanged"]),
    _createVNode(_component_progress_overlay, {
      visible: _ctx.isProcessing,
      sticky: true
    }, null, 8 /* PROPS */, ["visible"])
  ]))
}